// @react
import React, { ReactElement } from 'react'
// @typings
import { CommunicationFormValues } from 'modules/common/forms/types/communication'
// @libraries
import { UseFormMethods, Control, useWatch, Controller } from 'react-hook-form'
import { makeStyles } from '@material-ui/core/styles'
// @components
import InputCheckbox from '@bit/atd.web.forms.input-checkbox'

type PropsType = {
  formMethods: UseFormMethods<CommunicationFormValues>
  control: Control<CommunicationFormValues>
  isEditing: boolean
  watchFields: string[]
}

const useStyles = makeStyles(() => ({
  optionItem: {
    padding: '12px 24px 24px',
    borderBottom: '1px solid #dbd9d6',
    '&:last-child': {
      borderBottom: 'none',
    },
    '& > div': {
      width: '100%',
    },
  },
}))

const PromotionalOptionsFields = ({
  formMethods,
  control,
  isEditing,
  watchFields,
}: PropsType): ReactElement => {
  /****************************************
   *  STATES
   ****************************************/

  /****************************************
   *  HOOKS
   ****************************************/

  const classes = useStyles()
  const watchSelections = useWatch<CommunicationFormValues>({
    control,
    name: watchFields,
  })

  /****************************************
   *  RENDER
   ****************************************/

  return (
    <>
      <div className={classes.optionItem}>
        <Controller
          control={control}
          name="receivePromotionalCommunication"
          render={({ onChange, onBlur, value, name }) => (
            <InputCheckbox
              name={name}
              value={value}
              onBlur={onBlur}
              disabled={!isEditing}
              label="Promotional Communications"
              labelPlacement="right"
              size="medium"
              checked={watchSelections.receivePromotionalCommunication}
              onChange={() => {
                formMethods.setValue('fewerEmails', '', { shouldDirty: true })
                formMethods.setValue(
                  'receivePromotionalCommunication',
                  !watchSelections.receivePromotionalCommunication,
                  {
                    shouldValidate: false,
                    shouldDirty: true,
                  },
                )
              }}
              helperText={
                <span>
                  Receive emails from ATD advertisers, exhibitors, partners, and
                  sponsors.
                </span>
              }
            />
          )}
        />
      </div>
    </>
  )
}

export default PromotionalOptionsFields
